import { useState } from 'react';
import imgUser from '@/assets/icon/img-user.svg';
import { useSessionProfile } from '@/domains/auth/hooks/useSessionProfile';
import { cn } from '@/lib/utils';
import { useAuthStore } from '@/store/authStore';

interface UserProfileProps {
  nameClassName?: string;
}

/**
 * Signed-in user for the dashboard Sidebar (mobile) and Header (desktop):
 * Google photo (placeholder without one or when it fails), name (else the email)
 * and role (admin group or not).
 */
const UserProfile = ({ nameClassName }: UserProfileProps) => {
  useSessionProfile();
  const name = useAuthStore((state) => state.name);
  const email = useAuthStore((state) => state.email);
  const pictureUrl = useAuthStore((state) => state.picture_url);
  const isAdmin = useAuthStore((state) => state.is_admin);
  const [failedUrl, setFailedUrl] = useState<string>();
  const photo = pictureUrl && pictureUrl !== failedUrl ? pictureUrl : imgUser;

  return (
    <>
      <img
        src={photo}
        alt="user"
        referrerPolicy="no-referrer"
        onError={() => setFailedUrl(pictureUrl)}
        className="w-[36px] h-[36px] rounded-full object-cover"
      />
      <div className="w-fit min-w-0">
        <p className={cn('title2medium truncate', nameClassName)}>{name || email}</p>
        <p className="reg12 text-text-grey w-fit px-3 py-1 rounded-[4px] bg-text-blue-10">
          {isAdmin ? 'Admin' : 'Pengguna'}
        </p>
      </div>
    </>
  );
};

export default UserProfile;
